<div class="main-counter-div" [hidden]="!dashboardModel.invitationCounterVisible">
    <div class="header-div">
    <div class="counter-holder without-bottom-borders with-padding" >
         <div class="counter-card">
            <span class="counter-header">
                Invitations not yet accepted
            </span>
            <span class="counter-content">
                {{dashboardModel.invitationsNotAcceptedCount}}
            </span>
         </div>
    
         <div class="counter-card">
            <span class="counter-header">
                Invitations expiring (next 5 days)
            </span>
            <span class="counter-content orange-color">
                {{dashboardModel.invitationsExpiringCount}}
            </span>
         </div>
    
         <div class="counter-card">
            <span class="counter-header">
                Invitations expired
            </span>
            <span class="counter-content red-color">
               {{dashboardModel.invitationsExpiredCount}}
            </span>
         </div>
        </div>
        <div class="footer-div">
            Invitations sent in the last 4 weeks
        </div>
    </div>

    <div class="counter-holder w-25p">
        <div class="counter-card">
            <span class="counter-header">
                Coached Participants
            </span>
            <span class="counter-content">
                {{coachedParticipantCount}}
            </span>
            <mat-form-field>
            <mat-select placeholder="Last 30 Days" [(value)]="drpCoachParticipantValue" (selectionChange)="ondropdownchange()">
                <mat-option value="1">Last 30 Days</mat-option>
                <mat-option value="2">Last 3 Months</mat-option>
                <mat-option value="3">Last Year</mat-option>
            </mat-select>
        </mat-form-field>
        </div>
    </div>
    </div>